export default "assets/images/logo-ac756669.png";